import(/* webpackMode: "eager" */ "/home/runner/work/personal-website/personal-website/app/(tools)/tools/base64-tool/page.tsx");
